import { _ as _slicedToArray } from './slicedToArray-ibbgR3-O.js';
import { _ as _defineProperty } from './defineProperty-Y-S4SptN.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-w3bsUgPa.js';
import { forwardRef, useRef, useState, useCallback, memo } from 'react';
import ImageHolder from './ImageHolder/index.js';
import { H as HoverPaper } from './HoverPaper-ulm5jlA-.js';
import Loader from './Loader/index.js';
import { T as Tooltip } from './Tooltip-mQqB3TNx.js';
import GoldBadge from './GoldBadge/index.js';
import createUseStyles from './create/index.js';
import { textOverflowHidden } from './helpers/index.js';
import { FontWeights } from './fonts/index.js';
import { j as jsxRuntimeExports } from './jsx-runtime-KJzvSKZ_.js';
import classNames from 'classnames';

function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$3 = createUseStyles({
  root: {
    borderRadius: 4,
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    maxWidth: 'fit-content'
  },
  icon: {
    display: 'inline-block',
    position: 'absolute',
    left: 4,
    top: 4,
    zIndex: 2
  }
}, {
  name: 'hover-paper'
});
var useTitleStyles = createUseStyles({
  root: _objectSpread$4(_objectSpread$4({
    display: 'block',
    height: 16,
    borderRadius: function borderRadius(_ref) {
      var type = _ref.type;
      return type === 'circle' ? 16 : 0;
    },
    padding: [0, 4],
    fontWeight: FontWeights.SemiBold,
    fontSize: 10,
    color: 'var(--texts-tint-1)',
    textAlign: 'center'
  }, textOverflowHidden), {}, {
    lineHeight: '16px',
    boxShadow: function boxShadow(_ref2) {
      var type = _ref2.type;
      return type === 'basic' ? '0 -1px 0 0 var(--shadows-tint-1)' : 'none';
    },
    background: function background(_ref3) {
      var type = _ref3.type;
      return type === 'circle' ? 'var(--backgrounds-tint-3)' : 'none';
    }
  })
});

var _excluded$3 = ["className"],
  _excluded2 = ["paper", "children", "isLoading", "isPremium", "premiumTooltip", "selected", "pinableChildren", "showHover", "rootDataTestId", "imageClassName", "isDragDisabled", "onLoadImage", "onError"];
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Icon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/jsxRuntimeExports.jsx("span", {
    className: className,
    ref: ref,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(GoldBadge, _objectSpread$3({
      size: 16,
      "data-test": "crown-icon"
    }, rest))
  });
});
var IconWithTooltip = /*#__PURE__*/memo(function (_ref2) {
  var text = _ref2.text,
    className = _ref2.className;
  return /*#__PURE__*/jsxRuntimeExports.jsx(Tooltip, {
    overlay: text,
    mouseEnterDelay: 500,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(Icon, {
      className: className
    })
  });
});
function Thumbnail(_ref3, ref) {
  var paper = _ref3.paper,
    children = _ref3.children,
    isLoading = _ref3.isLoading,
    isPremium = _ref3.isPremium,
    _ref3$premiumTooltip = _ref3.premiumTooltip,
    premiumTooltip = _ref3$premiumTooltip === void 0 ? '' : _ref3$premiumTooltip,
    selected = _ref3.selected,
    _ref3$pinableChildren = _ref3.pinableChildren,
    pinableChildren = _ref3$pinableChildren === void 0 ? false : _ref3$pinableChildren,
    _ref3$showHover = _ref3.showHover,
    showHover = _ref3$showHover === void 0 ? true : _ref3$showHover,
    rootDataTestId = _ref3.rootDataTestId,
    imageClassName = _ref3.imageClassName,
    isDragDisabled = _ref3.isDragDisabled,
    _ref3$onLoadImage = _ref3.onLoadImage,
    onLoadImage = _ref3$onLoadImage === void 0 ? function () {} : _ref3$onLoadImage,
    _ref3$onError = _ref3.onError,
    onError = _ref3$onError === void 0 ? function () {} : _ref3$onError,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var styles = useStyles$3();
  var timerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var showChildren = useCallback(function () {
    timerRef.current = setTimeout(function () {
      return setShow(true);
    }, 150);
  }, []);
  var hideChildren = useCallback(function () {
    timerRef.current && clearTimeout(timerRef.current);
    setShow(false);
  }, []);
  return /*#__PURE__*/jsxRuntimeExports.jsx("div", _objectSpread$3(_objectSpread$3(_objectSpread$3({
    className: styles.root
  }, !pinableChildren && {
    onMouseEnter: showChildren
  }), !pinableChildren && {
    onMouseLeave: hideChildren
  }), {}, {
    "data-testid": rootDataTestId,
    ref: ref,
    children: /*#__PURE__*/jsxRuntimeExports.jsxs(HoverPaper, _objectSpread$3(_objectSpread$3({
      selected: selected,
      showHover: showHover
    }, paper), {}, {
      children: [isLoading && /*#__PURE__*/jsxRuntimeExports.jsx(Loader, {}), isPremium && !premiumTooltip && /*#__PURE__*/jsxRuntimeExports.jsx(Icon, {
        className: styles.icon
      }), isPremium && premiumTooltip && /*#__PURE__*/jsxRuntimeExports.jsx(IconWithTooltip, {
        text: premiumTooltip,
        className: styles.icon
      }), (pinableChildren || show) && children, /*#__PURE__*/jsxRuntimeExports.jsx(ImageHolder, _objectSpread$3({
        imageClassName: imageClassName,
        isDragDisabled: isDragDisabled,
        onError: onError,
        onLoad: onLoadImage
      }, props))]
    }))
  }));
}
var Thumbnail$1 = /*#__PURE__*/forwardRef(Thumbnail);

var _excluded$2 = ["children", "pin", "className"];
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$2 = createUseStyles({
  header: {
    position: 'absolute',
    display: function display(_ref) {
      var pin = _ref.pin;
      return pin ? 'block' : 'none';
    },
    top: 4,
    right: 4,
    zIndex: 2
  }
});
function Header(_ref2) {
  var children = _ref2.children,
    pin = _ref2.pin,
    className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded$2);
  var styles = useStyles$2({
    pin: pin
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx("div", _objectSpread$2(_objectSpread$2({
    className: classNames(styles.header, 'hoverPaperHeader', className)
  }, props), {}, {
    children: children
  }));
}
var Header$1 = /*#__PURE__*/memo(Header);

var _excluded$1 = ["children", "pin", "className"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1 = createUseStyles({
  footer: {
    position: 'absolute',
    display: function display(_ref) {
      var pin = _ref.pin;
      return pin ? 'block' : 'none';
    },
    bottom: 4,
    left: 4,
    right: 4,
    zIndex: 2,
    pointerEvents: 'none'
  }
});
function Footer(_ref2) {
  var children = _ref2.children,
    pin = _ref2.pin,
    className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded$1);
  var styles = useStyles$1({
    pin: pin
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx("div", _objectSpread$1(_objectSpread$1({
    className: classNames(styles.footer, 'hoverPaperFooter', className)
  }, props), {}, {
    children: children
  }));
}
var Footer$1 = /*#__PURE__*/memo(Footer);

var _excluded = ["children", "pin", "className", "isInteractableIcon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = createUseStyles({
  body: {
    position: 'absolute',
    display: function display(_ref) {
      var pin = _ref.pin;
      return pin ? 'block' : 'none';
    },
    zIndex: 2,
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    pointerEvents: function pointerEvents(props) {
      return props.isInteractableIcon ? 'none' : null;
    }
  }
});
function Body(_ref2) {
  var children = _ref2.children,
    pin = _ref2.pin,
    className = _ref2.className,
    isInteractableIcon = _ref2.isInteractableIcon,
    props = _objectWithoutProperties(_ref2, _excluded);
  var styles = useStyles({
    pin: pin,
    isInteractableIcon: isInteractableIcon
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx("div", _objectSpread(_objectSpread({
    className: classNames(styles.body, 'hoverPaperBody', className)
  }, props), {}, {
    children: children
  }));
}
var Body$1 = /*#__PURE__*/memo(Body);

export { Body$1 as B, Footer$1 as F, Header$1 as H, Thumbnail$1 as T, useTitleStyles as u };
//# sourceMappingURL=Body-3jUYBH5W.js.map
